const lbaLatLongMapSearch = angular.module('app.lbaLatLongMapSearch', []);

lbaLatLongMapSearch.controller('lbaLatLongMapSearchCtrl', require('./lbaLatLongMapSearchCtrl'));
lbaLatLongMapSearch.directive('lbaLatLongMapSearch', require('./lbaLatLongMapSearchDir'));

export default lbaLatLongMapSearch;



// WEBPACK FOOTER //
// ./src/components/lbaLatLongMapSearch/index.js